var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GroupTree',{attrs:{"GroupFlag":"area"},model:{value:(_vm.AreaId),callback:function ($$v) {_vm.AreaId=$$v},expression:"AreaId"}}),_c('div',[_vm._v("所选ID： "+_vm._s(_vm.AreaId))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }